import { PuzzleStatusConstants } from 'app-constants';

export const PuzzleStatusSelectOptions = Object.keys(PuzzleStatusConstants).map((key) => ({
  value: key,
  label: (PuzzleStatusConstants as any)[key]?.label,
}));
